class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const cartItems = this.closest("cart-items");
      cartItems.updateQuantity(this.dataset.index, 0);

      // Check if this is the IE store
      const isIEStore = shop && shop.permanent_domain && shop.permanent_domain.includes("vithit-drinks-ie");

      if (isIEStore) {
        const con_id = this.dataset.con_id;
        console.log(con_id, "con_id");

        // Disable checkout button during operation
        $('.cart__checkout-button').attr('disabled', true);

        setTimeout(() => {
          cartItems
            .querySelectorAll(`.cart-item[parent-con_id="${con_id}"]`)
            .forEach((ele) => cartItems.updateQuantity(ele.dataset.line, 0));

          // Re-enable checkout button
          $('.cart__checkout-button').attr('disabled', false);
        }, 1000);
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartErrors = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  isIEStore() {
    return shop && shop.permanent_domain && shop.permanent_domain.includes("vithit-drinks-ie");
  }

  onChange(event) {
    if (event.target === null) return;
  
    // Shared functionality
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );

    if (this.isIEStore()) {
      const con_id = event.target.dataset.con_id;
      console.log(con_id);
  
      const _this = this;
  
      setTimeout(function () {
        _this
          .querySelectorAll(`.cart-item[parent-con_id="${con_id}"]`)
          .forEach((ele) => {
            _this.updateQuantity(
              ele.dataset.line,
              event.target.value,
              document.activeElement.getAttribute("name")
            );
  
            console.log(ele.dataset.line, event.target.value, document.activeElement.getAttribute("name"));
  
            const data_price = ele.getAttribute("data-price"),
              data_qty = ele.getAttribute("data-qty");
  
            console.log(data_price, "<<", data_qty, ">>");
  
            setTimeout(function () {
              console.log(data_qty, "ele>>>>>>>>", data_price);
            }, 5000);
          });
      }, 2000);
    }
  }

  getSectionsToRender() {

    const mainCartElement = document.getElementById('main-cart');
    const mainCartSectionId = mainCartElement ? mainCartElement.dataset.id : null;

    let sections = [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section',
      },
      {
        id: 'main-cart',
        section: mainCartSectionId,
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
    if (document.querySelector('#main-cart .free-shipping')) {
      sections.push({
        id: 'main-cart',
        section: document.getElementById('main-cart')?.dataset.id,
        selector: '.free-shipping',
      });
    }
    return sections;
  }

  updateQuantity(line, quantity, name) {
    if (this.isIEStore()) {
      console.log(quantity,'quantity');
      $('[data-qty]').val(quantity);
    }
    
    this.enableLoading(line);
    const sectionsToRenderConfig = this.getSectionsToRender();
    const sectionsToRequest = sectionsToRenderConfig.map((section) => section.section);

    const uniqueSectionsToRequest = [...new Set(sectionsToRequest)];

    const body = JSON.stringify({
      line,
      quantity,
      sections: uniqueSectionsToRequest,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);

        // --- Re-rendering Logic ---
        sectionsToRenderConfig.forEach((sectionConfig => {
          const element = document.getElementById(sectionConfig.id); // Find the target DOM element by its ID

          if (element) {
            const sectionHtml = parsedState.sections[sectionConfig.section]; // Get the NEW HTML for the requested section ID

            if (sectionHtml) {
              // If selector is the element ID itself, replace its innerHTML
              if (sectionConfig.selector === `#${sectionConfig.id}`) {
                 // Parse the *entire* new section HTML response
                 const tempDiv = new DOMParser().parseFromString(sectionHtml, 'text/html');
                 // Find the element *within the parsed response* that matches our target ID
                 const newContentElement = tempDiv.getElementById(sectionConfig.id);
                 if (newContentElement) {
                     // Replace the innerHTML of the *existing* element with the innerHTML of the *newly parsed* element
                     element.innerHTML = newContentElement.innerHTML;
                 } else {
                     console.warn(`Could not find element with ID "${sectionConfig.id}" in received HTML for section "${sectionConfig.section}".`);
                 }
              } else {
                  // Original logic for replacing content within a specific selector inside the element
                  const elementToReplace = element.querySelector(sectionConfig.selector) || element;
                  const newInnerHTML = this.getSectionInnerHTML(sectionHtml, sectionConfig.selector);
                  if (newInnerHTML !== null && newInnerHTML !== undefined) {
                    elementToReplace.innerHTML = newInnerHTML;
                  } else {
                    console.warn(`Could not find selector "${sectionConfig.selector}" in section HTML for ID "${sectionConfig.id}" (Section: ${sectionConfig.section})`);
                  }
              }
            } else {
                console.warn(`No section HTML returned in response for section ID "${sectionConfig.section}" (Element ID: ${sectionConfig.id})`);
            }
          } else {
             console.warn(`Element with ID "${sectionConfig.id}" not found in current DOM.`);
          }
        }));
        // --- End Re-rendering Logic ---

        if (parsedState.errors) {
          this.updateErrorLiveRegions(line, parsedState.errors);
        }
        this.updateQuantityLiveRegions(line, parsedState.item_count);

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name) lineItem.querySelector(`[name="${name}"]`)?.focus(); // Add null check

        this.disableLoading();

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state // Pass the raw state string
          }
        }));
        // Consider if PUB_SUB_EVENTS needs the parsed state instead
        // publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cart: parsedState });
      })
      .catch((error) => {
        console.error('Error updating cart:', error); // Log the actual error
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
  }
  
  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
  
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
  
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  
  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector('.cart-item__error-text')
          .innerHTML = theme.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          ); 
      }
    }

    this.currentItemCount = itemCount;
    
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    
    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
  }
}
customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('cart-note', CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${theme.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';
          
          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);
